import { useEffect } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import CareButton from './CareButton';

export default function Modal({ isOpen, handleClose, children, title = 'Finestra di dialogo' }) {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    if (isOpen) {
      window.__modalOpen = true;
      window.lenis?.stop();

      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    } else {
      window.__modalOpen = false;
      window.lenis?.start();

      html.style.overflow = '';
      body.style.overflow = '';
    }

    return () => {
      window.__modalOpen = false;
      window.lenis?.start();
      html.style.overflow = '';
      body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onClose={handleClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-900/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
          <DialogPanel
            transition
            className="relative w-full max-w-[50%] rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:p-6 max-h-[90vh] flex flex-col overflow-hidden"
          >
            <DialogTitle className="text-xl font-semibold text-black w-full text-center">
              {title}
            </DialogTitle>
            <div className="mt-3 sm:mt-5 flex-1 min-h-0">
              <div
                className="mt-2 text-sm text-black overflow-y-auto max-h-[70vh] overscroll-contain"
                onWheel={(e) => e.stopPropagation()}
                onTouchMove={(e) => e.stopPropagation()}
              >
                {children}
              </div>
            </div>

            <div className="mt-5 sm:mt-6 flex justify-center">
              <CareButton buttonName="Chiudi" handleButtonClick={handleClose} />
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}